export default "__VITE_ASSET__a4d65cb5__"